module.exports = __webpack_public_path__ + "static/media/ball.15e17b83.webp";